<template>
    <VJoyWrapper class="white-label-container" no-margin direction="row" justify="flex-start" wrap="nowrap" column-gap="2">
        <VJoyCompanyAvatar size="medium" :company-name="companyName" :img-src="computedCompanyLogo" :img-alt="companyName" />
        <Transition name="fade">
            <div v-if="!isReduced" class="white-label-text" :title="companyName">{{ companyName }}</div>
        </Transition>
    </VJoyWrapper>
</template>
<script setup lang="ts">
    import {VJoyWrapper, VJoyCompanyAvatar} from '@maltjoy/core-vue';
    import {computed} from 'vue';

    const props = defineProps<{
        companyName?: string;
        companyLogo?: string;
        isReduced: boolean;
    }>();

    const computedCompanyLogo = computed(() => `${props.companyLogo}?func=crop&w=30&h=30`);
</script>
<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    .white-label-container {
        padding: var(--joy-core-spacing-3);
        margin: var(--joy-core-spacing-4) var(--joy-core-spacing-2) 6px !important;
        border-radius: var(--joy-core-radius-3);
        height: 48px;
        @include text.getFontBySize(primary-450);

        .joy-company-avatar img {
            object-fit: contain;
        }

        .white-label-text {
            width: 180px;
            max-width: 180px;
            flex: 0 0 auto;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            overflow: hidden;
        }
    }
</style>
